module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-ja.jpg?f52a55b9";